import React, { useEffect, createElement, Component } from 'react';
// Components
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatsIncluded } from './components/WhatsIncluded';
import { BonusSection } from './components/BonusSection';
import { PackImage } from './components/PackImage';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel via raw script injection
    const pixelId = '1322033292727002';
    // Avoid duplicate initialization
    if ((window as any).fbq) return;
    const f = window as any;
    const n = f.fbq = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args);
      } else {
        n.queue.push(args);
      }
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    // Load the Facebook pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
    // Initialize and track page view
    f.fbq('init', pixelId);
    f.fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#C67B30] selection:text-white" data-id="element-0">
      <StickyTopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProof data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <EmotionalTransition data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <WhatsIncluded data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PackImage data-id="element-10" />
        <UrgencySection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <TrustBar data-id="element-15" />
        <FAQSection data-id="element-16" />
      </main>

      <PurchasePopup data-id="element-17" />
    </div>;
}